import { MARQUEE } from "@/data/content";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div data-testid="editorial-marquee" className="relative border-y-[3px] border-black bg-[#FFEF00] py-5 md:py-7 overflow-hidden -rotate-1 my-10">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {items.map((t, i) => (
          <span key={i} className="flex items-center font-display font-black uppercase text-3xl md:text-5xl text-black px-6">
            {i % 2 ? <span className="text-transparent" style={{ WebkitTextStroke: "1.5px #000" }}>{t}</span> : t}
            <span className="ml-12 text-[#0A80C0]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
